module.exports = __webpack_public_path__ + "static/media/998128.c636e11a.png";